exports.components = {
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-templates-simple-page-index-jsx": () => import("./../../../src/templates/simple-page/index.jsx" /* webpackChunkName: "component---src-templates-simple-page-index-jsx" */)
}

